import React from "react";

interface ICustomModalProps<T> {
  title: string;
  subtitle: string;
  onAccept: (args: T) => void;
  onCancel?: () => void;
  args: T;
  isOpenCustomModal: boolean;
  setIsOpenCustomModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export function CustomModal<T>({
  title,
  subtitle,
  isOpenCustomModal,
  setIsOpenCustomModal,
  args,
  onAccept,
  onCancel,
}: ICustomModalProps<T>) {
  const handleAccept = () => {
    onAccept(args);
    setIsOpenCustomModal(false);
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    setIsOpenCustomModal(false);
  };

  return isOpenCustomModal ? (
    <div className="imm_admin__custom_modal">
      <div className="custom_modal__container">
        <div className="custom_modal__header">
          <h4>{title}</h4>
          <p>{subtitle}</p>
        </div>
        <div className="custom_modal__actions">
          <button className="modal__decline_btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="modal__accept_btn" onClick={handleAccept}>
            Proceed
          </button>
        </div>
      </div>
    </div>
  ) : null;
}
